import React, { useCallback } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import {
  downloadLibrary,
  downloadLibraryCloudfront,
  insertLibrary,
  requestLibraryCount,
  requestLibraryList,
} from 'redux/actions/library/actions';

import LibraryParamVO from 'commons/vo/param/LibraryParamVO';
import useError from './useError';
import KeyFlowError from 'commons/framework/KeyFlowError';
import { NO_PARTIAL_WITHDRAWAL_NAME_ERROR } from 'commons/constants/KeyFlowMessage';

function useLibrary() {
  const dispatch = useDispatch();

  const { onThrowError } = useError();

  const onRequestLibraryList = useCallback(
    (param: LibraryParamVO) => {
      dispatch(requestLibraryList({ param }));
    },
    [dispatch],
  );

  const onInsertLibrary = useCallback(
    (param: LibraryParamVO) => {
      const { contents } = param;
      if (!contents || !contents.trim()) {
        onThrowError(new KeyFlowError(NO_PARTIAL_WITHDRAWAL_NAME_ERROR));
        return;
      }
      dispatch(insertLibrary({ param }));
    },
    [dispatch],
  );

  const onDownloadLibraryCloudfront = useCallback(
    (path: string, videoId: number, id: number, filename: string) => {
      dispatch(downloadLibraryCloudfront({ videoPath: path, videoId, id, filename }));
    },
    [dispatch],
  );

  const onDownloadLibrary = useCallback(
    (param: { id: number; assetId: number }) => {
      dispatch(downloadLibrary(param));
    },
    [dispatch],
  );

  return {
    onRequestLibraryList,
    onInsertLibrary,
    onDownloadLibrary,
    onDownloadLibraryCloudfront,
  };
}

export default useLibrary;
